import { z } from 'zod';

const ClientEnvSchema = z.object({
  VITE_SUPABASE_URL: z.url(),
  VITE_SUPABASE_PUBLISHABLE_KEY: z.string().min(1),
  VITE_APP_VERSION: z.string().min(1),
  VITE_SUMMARISE_TICKER_URL: z.url(),
});

export type ClientEnv = z.infer<typeof ClientEnvSchema>;

function parseEnv(): ClientEnv {
  const parsed = ClientEnvSchema.safeParse(import.meta.env);
  if (!parsed.success) {
    console.error('[env] Invalid client environment:', z.flattenError(parsed.error));
    throw new Error('Invalid client environment. See console for details.');
  }
  return parsed.data;
}

export const env: ClientEnv = parseEnv();
